var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStaffPassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5.83333 9.66797V6.33464C5.83333 5.22957 6.27232 4.16976 7.05372 3.38836C7.83512 2.60696 8.89493 2.16797 10 2.16797C11.1051 2.16797 12.1649 2.60696 12.9463 3.38836C13.7277 4.16976 14.1667 5.22957 14.1667 6.33464V9.66797M4.16667 9.66797H15.8333C16.7538 9.66797 17.5 10.4142 17.5 11.3346V17.168C17.5 18.0884 16.7538 18.8346 15.8333 18.8346H4.16667C3.24619 18.8346 2.5 18.0884 2.5 17.168V11.3346C2.5 10.4142 3.24619 9.66797 4.16667 9.66797Z",
    stroke: "#0C66E4",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffPassword);
export default __webpack_public_path__ + "static/media/staffPassword.6234a14b619857a430a255d8047cc998.svg";
export { ForwardRef as ReactComponent };